import moment from 'moment'
import jwtDecode from 'jwt-decode'
export default {
    isJwtExpired(jwtToken) {
        const decodedJwtToken = jwtDecode(jwtToken)
        const jwtTokenExpirationTime = decodedJwtToken.exp
        return moment().unix() > jwtTokenExpirationTime
    }
}
